import { ArrowRight, PhoneCall } from "lucide-react";
import Reveal from "@/components/Reveal";

export const CtaBanner = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section data-testid="cta-banner" className="relative py-24 lg:py-32 overflow-hidden bg-[#0B1220] text-white">
      <div
        className="absolute inset-0 opacity-60"
        style={{
          backgroundImage:
            "radial-gradient(900px circle at 85% 50%, rgba(0,67,156,0.35), transparent 60%), radial-gradient(700px circle at 10% 0%, rgba(168,137,88,0.10), transparent 60%)",
        }}
        aria-hidden
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-7">
          <div className="text-[11px] uppercase tracking-[0.2em] font-semibold text-[#A88958] mb-5">Begin a project</div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Have a venue?
            <br />
            <span className="text-white/55">Let’s build for it.</span>
          </h2>
          <p className="mt-7 text-base lg:text-lg text-white/70 max-w-2xl leading-relaxed">
            Share your venue, audience, and timeline. A specifier replies within one business
            day with an LED or LCD plan, panel options, and a transparent budget.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-5 flex flex-col gap-3">
          <button
            data-testid="cta-banner-primary"
            onClick={() => go("contact")}
            className="group inline-flex items-center justify-between gap-3 px-6 py-5 bg-white text-[#0B1220] font-semibold rounded-lg hover:bg-[#00439C] hover:text-white transition shadow-2xl"
          >
            <span className="text-base">Request a Quote</span>
            <ArrowRight size={18} className="group-hover:translate-x-0.5 transition" />
          </button>
          <a
            href="tel:+919818482197"
            data-testid="cta-banner-secondary"
            className="inline-flex items-center justify-between gap-3 px-6 py-5 border border-white/20 text-white font-semibold rounded-lg hover:bg-white/5 transition"
          >
            <span className="inline-flex items-center gap-2 text-base"><PhoneCall size={16} /> +91 98184 82197</span>
            <span className="text-[10px] uppercase tracking-[0.18em] text-white/55 font-semibold">Sales</span>
          </a>
          <div className="mt-3 text-xs text-white/45 text-center">
            Response within 1 business day
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaBanner;
